import React from 'react';
import Banner from '../Banner/Banner';
import CoreValue from '../CoreValue/CoreValue';
import Different from '../Different/Different';
import MisionVision from '../MissionVision/MisionVision';
import Navbar from '../Navbar/Navbar';

const PageFive = () => {
    return (
        <>
            <Navbar />
            <Banner />
            <CoreValue />
            <MisionVision />
            <Different />
        </>
    );
};

export default PageFive;